export default "__VITE_ASSET__DCzS9hXG__"